import styled from 'styled-components';

export const IntroContainer = styled.div`
  padding: 16px;
`;
